/*
*###############################################################################
*Module Name                   : CompanyMaster.js                              #
*Purpose of the Module         :                                               #
*Description of the Module     :                                               #
*Original Author               : I Dinisuru Balasuriya                         #
*Date                          : Friday, September 16th 2021, 09:49:55 am      #
*Copyright © 2021 myPOS Software Solution (pvt Ltd.)                           #
*###############################################################################
*/

import React, { useState, useEffect, useContext } from 'react'
import { MetaTags } from 'react-meta-tags'
import {
    Card,
    Col,
    Container,
    Row,
    CardBody,
} from 'reactstrap'

//**Importing required componant files   */
import Breadcrumb from 'components/Common/Breadcrumb'
import DPTopToolBar from 'framework/widgets/DPTopToolBar'
import CompanyMasterContent from './CompanyMasterContent'
import DPInfoBox from 'framework/layout/DPInfoBox'
import { Text } from "../../../framework/validators/TextValidation"
import DPAlert from "../../../framework/widgets/DPAlert"
import DPLoadingAlert from 'framework/widgets/DPLoadingAlert'
import DPPermission from "framework/widgets/DPPermission"
import * as XLSX from "xlsx";
import uuid from 'react-uuid'

import { Context } from '../../../app-contexts/CommonContexts';
import { useHistory } from 'react-router-dom';
var jwt = require('jsonwebtoken');

const moment = require('moment');

import DPPrintOption from 'framework/widgets/DPPrintOptions'
import { CompanyGetData, DeleteComapanyDetails, SaveComapanyDetails, SaveCompanyListDetails, } from './CompanyController'

//**End Importing required componant files */

const CompanyMaster = (props) => {

    let history = useHistory();

    //*** User input related states */
    const [strCompCode, SetCode] = useState("");// Set Code
    const [strCompDesc, SetDescription] = useState("")//Set Description
    const [IsActive, SetActive] = useState(true)//Set Active state
    const [menuCode, SetMenuCode] = useState("")
    //*** End User input related states */

    //**Tooltip  Variables*/
    const [ttCode, SetTTCode] = useState('')
    const [ttDescription, SetTTDescription] = useState('')
    const [ttStatus, SetTTStatus] = useState('')

    //**End Tool tip Variables */ */

    //*** User Activity related states*/
    const [show, setShow] = useState(false)
    const [AlertMsg, setAlertMsg] = useState('')
    const [AlertColor, setAlertColor] = useState('')
    const [modal_xlarge, setmodal_xlarge] = useState(false)
    const [disabled, setDisabled] = useState(false)
    const [disabledCode, setDisabledCode] = useState(false)
    const [saveEnable, setSaveEnable] = useState(true)
    const [crEnable, setCrEnable] = useState(false)
    const [crBy, setCrBy] = useState("")
    const [mdBy, setMdBy] = useState("")
    const [crDate, setCrDate] = useState("")
    const [mdDate, setMdDate] = useState("")
    const [deleteEnable, SetDeleteEnable] = useState(false)
    const [Reason, setReason] = useState("Created")
    const [editEnable, SetEditEnable] = useState(false)
    //*** End User activity related staes */

    //Alert Parameter
    const [sweetAlertShow, setsweetAlertShow] = useState(false)
    const [AlertDescription, setAlertDescription] = useState(false)
    const [AlertConfirmOption, setAlertConfirmOption] = useState(0)
    const [ErrorMsg, setErrorMsg] = useState('')
    const [addNew, SetAddNew] = useState(true)
    //*****Menu Rights Start*/
    const [menuAccess, SetMenuAccess] = useState(false)
    const [menuCreate, SetMenuCreate] = useState(false)
    const [menuDelete, SetMenuDelete] = useState(false)
    const [menuModify, SetMenuModify] = useState(false)
    const [menuPrint, SetMenuPrint] = useState(false)
    const [menuProcess, SetMenuProcess] = useState(false)
    const [menuName, SetMenuName] = useState("")
    const [parentName, SetParentName] = useState("")
    const [LocationCode, setLocationCode] = useState("")
    const [LogUserType, setLogUserType] = useState("")
    const [LogCompanyCode, setLogCompanyCode] = useState("")
    //*****Menu Rights End */

    /**********Loading Alert */
    const [loadingAlert, SetLoadingAlert] = useState(false)
    const [loadingAlertTitle, SetLoadingAlerttitle] = useState("")
    /**********End Loading Alert */

    //autocode generation related newly added code
    const [codeButton, setCodeButton] = useState(true)
    const [searchdisabled, setSearchdisabled] = useState(false)
    const [nullCode, setNullCode] = useState(false)
    const [autoCode, setAutoCode] = useState(false)

    //User Permission related usestates
    const [permissionAlertShow, setPermissionAlertShow] = useState(false)
    const [permissionAlertTitle, setPermissionAlertTitle] = useState("")
    const [permissionReasonShow, setPermissionReasonShow] = useState(true)
    const [permissionName, setPermissionName] = useState("")
    const [permissionPassword, setPermissionPassword] = useState("")
    const [permissionNameDisable, setPermissionNameDisable] = useState(false)

    const [printoptionShow, setprintoptionShow] = useState(false)

    const [valueUpload, setvalueUpload] = useState("")
    const [items, setItems] = useState([]);
    const [Excelitems, setExcelItems] = useState([]);

    var time = process.env.REACT_APP_ALERTTIMEOUT
    const ApiURL = window.Links.ApiURL //
    const authToken = localStorage.getItem("authToken")


    //websocket related states
    const [menuRight, setMenuRight] = useState("")
    //const [ws, setWs] = useState(new WebSocket(`${socketURl}api/WebSocket/ws`));
    const [locationName, setLocationName] = useState("")

    //**Permission Granted Alert usestates */
    const [editCheck, setEditCheck] = useState(false)
    const permissionedUser = React.useRef('')
    const permissionedReason = React.useRef('')
    const [permissionGrantedAlertShow, setPermissionGrantedAlertShow] = useState(false)
    const [permissionGrantedAlertMsg, setPermissionGrantedAlertMsg] = useState("")
    const [permissionGrantedAlertColor, setPermissionGrantedAlertColor] = useState("")
    const [helpUrl, setHelpUrl] = useState("")
    const [isReload, setIsReload] = useState(false)

    const controller = new AbortController()
    const signal = controller.signal

    //alert related states
    let universalID = ''
    // var date2 = ""
    var updateUrld = ""
    var menurightaccept = ''
    // const myAlertURL = window.Links.MyAlertUrl

    const [uniqueid, setUniqueid] = useState('')
    const [putrequest, setPutrequest] = useState("")
    const [putreqdate, setPutreqdate] = useState("")
    const [alertPort, setAlertPort] = useState("")
    const [alertUserGroups, setAlertUserGroups] = useState([])

    //**End alert related states */

    //import from contexts
    const {
        isHeadOffice, getMenuDetails, masterAuditLog, getSelectedMasterPermissions, fetchAutoCode, addtoFavourite, FetchUserGroups, FetchPortID,
        sendApprovalNotification, PublishMessage, FetchDeviceUserDetails
    } = useContext(Context);
    //import from contexts

    const readExcel = (file) => {
        const promise = new Promise((resolve, reject) => {
            const fileReader = new FileReader();
            fileReader.readAsArrayBuffer(file);

            fileReader.onload = (e) => {
                const bufferArray = e.target.result;

                const wb = XLSX.read(bufferArray, { type: "buffer" });
                const wsname = wb.SheetNames[0];
                const ws = wb.Sheets[wsname];

                const data = XLSX.utils.sheet_to_json(ws);
                setExcelItems(data);
                resolve(data);
            };

            fileReader.onerror = (error) => {
                reject(error);
            };
        });

        promise.then((d) => {
            setItems(d);
        });
    };

    useEffect(async () => {

        var obj = JSON.parse(localStorage.getItem("authUser"))
        var LogUserType = obj[2]
        var LocationCode = obj[3]
        var LocationName = obj[4]
        var CompanyCode = obj[5]
        var menuDetail = await getMenuDetails(window.location.pathname)
        var menu = menuDetail && menuDetail.menuTag ? menuDetail.menuTag : history.push('/dashboard');
        var parentname = menuDetail?.parentName
        SetParentName(parentname)
        setLocationCode(LocationCode)
        setLocationName(LocationName)
        setLogUserType(LogUserType)
        setLogCompanyCode(CompanyCode)

        var responseData = await getSelectedMasterPermissions(LogUserType, menu)

        if (!responseData.strMenuAccessRight) {
            history.push('/dashboard')
        }

        SetMenuAccess(responseData.strMenuAccessRight)
        SetMenuCreate(responseData.strMenuCreateRight)
        SetMenuDelete(responseData.strMenuDeleteRight)
        SetMenuModify(responseData.strMenuModifyRight)
        SetMenuPrint(responseData.strMenuPrintRight)
        SetMenuProcess(responseData.strMenuProcessRight)
        SetMenuName(responseData.strMenuName)
        SetMenuCode(responseData.strMenuTag)
        setPermissionReasonShow(responseData.strMenuReasonShow)
        setHelpUrl(responseData.strHelpUrl)

        var autoCodeRes = await fetchAutoCode(menu)

        if (autoCodeRes.nullCode == false) {
            setAutoCode(autoCodeRes.autoCode)
        } else {
            setNullCode(true)
            setAutoCode("")
        }

        await fetch(`${ApiURL}common/GetToolTip/${menu}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${authToken}`
            },
        }).then(async (Response) => await Response.json())
            .then(responseData => {
                if (responseData.success == true) {
                    if (responseData.data.length != 0) {
                        var dt = responseData.data

                        dt.map((item, index) => {
                            if (item.toolTipField == 'CC_CODE') {
                                SetTTCode(item.toolTipText)
                            }

                            if (item.toolTipField == 'CC_DESC') {
                                SetTTDescription(item.toolTipText)
                            }

                            if (item.toolTipField == 'CC_STATUS') {
                                SetTTStatus(item.toolTipText)
                            }

                        })
                    }
                }
            })
    }, [isReload])


    // AuditLog
    useEffect(async () => {

        var obj = JSON.parse(localStorage.getItem("authUser"))
        var LogUserType = obj[2]
        var LocationCode = obj[3]
        var CompanyCode = obj[5]
        var menuDetail = await getMenuDetails(window.location.pathname)
        var menu = menuDetail && menuDetail.menuTag ? menuDetail.menuTag : history.push('/dashboard');

        await masterAuditLog(menu, LogUserType, LocationCode, CompanyCode) //masterfile access log

    }, [])

    //*** Get and Set values when user search code */
    async function getData(searchData) {

        if (searchData == "") return

        SetLoadingAlert(true)
        SetLoadingAlerttitle("Fetching...")

        const result = await CompanyGetData(searchData);

        SetLoadingAlert(false)

        if (result.success == true) {

            SetDescription(result.data.name)
            SetActive(result.data.status)
            setCrBy(result.data.createdBy)
            setCrDate(result.data.createdDate)
            setMdBy(result.data.modifiedBy)
            setMdDate(result.data.modifiedDate)
            setCrBy(result.data.createdBy)
            setMdBy(result.data.modifiedBy)
            setCrDate(result.data.createdDate)
            setMdDate(result.data.modifiedDate)
            setCrEnable(true)
            SetAddNew(false)
            setDisabled(true)
            setDisabledCode(true)
            setSaveEnable(false)
            SetDeleteEnable(true)
            setSearchdisabled(true)
            setReason("Updated")
            SetEditEnable(true)

        } else if (result.success == false) {
            if (nullCode == false) {
                setDisabledCode(true)
                displayAlertMessage('success', "Record Not Found !")
                SetCode("")
            }

        }
    }

    //*** End useEffect */

    function tog_xlarge() {
        setmodal_xlarge(!modal_xlarge)
        removeBodyCss()
    }

    //removebodyCss function
    function removeBodyCss() {
        document.body.classList.add("no_padding")
    }

    function stringToBool(value) {
        value = value.toString().toLowerCase();
        return value === "1" || value === "true"

    }

    //save button function
    const handlesave = async (e) => {
        var ExcelItemsRows = [...Excelitems]
        if (Array.isArray(ExcelItemsRows) && ExcelItemsRows.length) {
            var saveList = []
            ExcelItemsRows.map(async (localState) => {
                if ((localState.Code != null) && (localState.Description != null) && (localState.Active != null) || !localState.Active) {
                    saveList.push({
                        CompanyCode: localState.Code,
                        CompanyName: localState.Description,
                        IsActive: stringToBool(localState.Active),
                    })
                }
            })

            const companyArray = {
                CompanyList: saveList,
                User: LogUserType,
                MenuCode: menuCode,
                LoggedCompany: LogCompanyCode,
                LoggedLocation: LocationCode,
                Reason: Reason,
                CreateBy: LogUserType,
            }


            var response = await SaveCompanyListDetails(companyArray);

            if (response.success) {
                displayAlertMessage("success", response.message)

            } else {
                displayAlertMessage("danger", response.message)

            }

        } else {

            //set autogenerate code to as CODE just for display purpuse
            if (addNew == true && nullCode == false) {
                SetCode(autoCode)
            }

            /*******************************/

            if (strCompCode == "" && nullCode == true) {
                displayAlertMessage('danger', "Please Enter Customer Group Code !")
                return;

            }
            if (strCompDesc == "") {
                displayAlertMessage('danger', "Please Enter description")
                return;

            }


            const customerDesignation = {
                strCompanyCode: addNew == true && nullCode == false ? autoCode : strCompCode,
                strCompanyName: strCompDesc,
                IsActive: IsActive,
                strMenuCode: menuCode,
                strLoggedCompany: LogCompanyCode,
                strLoggedLocation: LocationCode,
                strReason: permissionedReason.current != "" ? permissionedReason.current : Reason,
                strCreateBy: permissionName == "" ? permissionedUser.current : permissionName,
                blAddNew: addNew
            }

            SetLoadingAlert(true)
            if (addNew == true) {
                SetLoadingAlerttitle("Saving...")
            } else {
                SetLoadingAlerttitle("Updating...")
            }


            //*** save/update records */
            const result = await SaveComapanyDetails(customerDesignation);

            SetLoadingAlert(false)

            if (result.success) {
                displayAlertMessage("success", result.data)
                ClearItem()
            } else {
                if (result.data == "Code Already Exsist!") {
                    setCodeButton(false)
                }
                displayAlertMessage("danger", result.data)
            }
        }
    }

    const PermissionLog = () => {

    }

    //*** Get user selected row details */
    const GetSelectRow = (e, row, isSelect, rowIndex) => {
        SetCode(row.CC_CODE);
        getData(row.CC_CODE)
        setDisabled(true)
        setDisabledCode(true)
        setSaveEnable(false)
        setmodal_xlarge(!modal_xlarge);
        setCrEnable(true)

    }
    //*** End of getSelectedRow function */

    //edit button function    
    const handleEdit = e => {
        setDisabled(false)
        setDisabledCode(true)
        setSaveEnable(true)
        SetDeleteEnable(true)
        SetEditEnable(false)
        setEditCheck(true)
    }

    //new button function
    const handleNew = e => {
        // e.preventDefault()
        ClearItem();
        setShow(false)
        setSaveEnable(true)
        setCrEnable(false)
    }

    //clear fields function    
    const ClearItem = () => {
        SetCode("")
        SetDescription("")
        SetActive(true)
        setDisabledCode(false)
        setDisabled(false)
        setCrEnable(false)
        SetAddNew(true)
        setErrorMsg('')
        SetDeleteEnable(false)
        setNullCode(false)
        setSearchdisabled(false)
        setReason("Created")
        SetEditEnable(false)
        setSaveEnable(true)
        setPermissionName("")
        setPermissionPassword("")
        setPermissionNameDisable(false)
        setCodeButton(true)
        setvalueUpload("")
        setExcelItems([])
        setIsReload(!isReload)
        setEditCheck(false)
        permissionedUser.current = ""
    }

    //********Delete button function */
    const handleDelete = async () => {

        //loading alert show
        SetLoadingAlert(true)
        SetLoadingAlerttitle("Deleting...")

        const rowDelete = {
            strMenuCode: menuCode,
            strCode: strCompCode,
            strLoggedCompany: LogCompanyCode,
            strLoggedLocation: LocationCode,
            strReason: Reason,
            strCreateBy: LogUserType
        }

        const result = await DeleteComapanyDetails(rowDelete);

        SetLoadingAlert(false)

        if (result.success) {
            displayAlertMessage("success", result.data)
            ClearItem()

        } else {
            displayAlertMessage("danger", result.data)
        }
    }
    //*********Delete button function end */

    // print Function
    async function handlePrint(option) {

        var option = option
        SetLoadingAlert(true)
        SetLoadingAlerttitle("Generating Report...")

        const ReportURL = window.Links.ReportURL
        await fetch(`${ReportURL}api/Company/report/${LogUserType}/${option == "PDF" ? 1 : 0}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${authToken}`
            }
        }).then(Response => Response.json())
            .then(responseData => {
                if (responseData.success == true) {
                    // PermissionLog()
                    if (option == "PDF") {
                        const msg = responseData.msg
                        window.open(`${ReportURL}temp_print/${msg.replace("\r\n", '')}.pdf`)
                    }
                    if (option == "XCEL") {
                        const msg = responseData.msg
                        window.open(`${ReportURL}temp_print/${msg.replace("\r\n", '')}.xls`)
                    }
                }

                SetLoadingAlert(false)

            }).catch(error => {
                console.log(error.message)
                SetLoadingAlert(false)
            })
    }

    //CODE AUTO GEN
    const AutoGenerateCode = async () => {

        await fetch(`${ApiURL}common/autocode/${menuCode}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${authToken}`
            },
        }).then(Response => Response.json())
            .then(responseData => {
                if (responseData.success == true) {
                    if (responseData.data.length > 0) {
                        SetCode(responseData.data)
                        setAutoCode(responseData.data)
                    } else {
                        setDisabledCode(false)
                    }
                }
            })
    }
    //**Permission Check */


    const AlertUpdate = (stste) => {
        var object = {
            "uuid": uniqueid,
            "status": stste,
        }

        var token = jwt.sign(object, "myposJWTauthentication")

        var obj = {
            "token": token,
            "menuCode": menuCode,
            "menuName": menuName,
            "userGroup": alertUserGroups,
        }

        // fetch(`${myAlertURL + alertPort}/notification/approval/update`, {
        //     method: "POST",
        //     headers: {
        //         "Content-Type": "application/json",
        //         "Authorization": `Bearer ${authToken}`
        //     },
        //     body: JSON.stringify(obj)
        // }).then(Response => Response.json())
        //     .then(responseData => {
        //         console.log(responseData)
        //     }).catch(errorr => {
        //         console.log(errorr)
        //     })
    }


    const PermissionCheck = (operation) => {

        const permissiondata = {
            strUsername: permissionName,
            strPassword: permissionPassword,
            strLocation: LocationCode,
            strMenuCode: menuCode
        }

        clearPermissionInputs()

        fetch(`${ApiURL}login/userpermission`,
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${authToken}`
                },
                body: JSON.stringify(permissiondata)
            }
        ).then(Response => {
            if (Response.status == "200") {
                Response.json()
                    .then(responseData => {
                        let Access = (responseData.data.strMenuAccessRight)
                        let Create = (responseData.data.strMenuCreateRight)
                        let Delete = (responseData.data.strMenuDeleteRight)
                        let Modify = (responseData.data.strMenuModifyRight)
                        let Print = (responseData.data.strMenuPrintRight)
                        let Process = (responseData.data.strMenuProcessRight)

                        if (operation == "Save") {
                            if (Create == true) {
                                handlesave()
                                AlertUpdate("APPROVED")
                            } else {
                                if (operation == "Save" && addNew == true) {
                                    displayAlertMessage('danger', "This user dosen't have permission to save")
                                    AlertUpdate("REJECTED")
                                } else {
                                    displayAlertMessage('danger', "This user dosen't have permission to edit")
                                    AlertUpdate("REJECTED")
                                }
                            }
                        } else if (operation == "Modify") {
                            if (Modify == true) {
                                handlesave()
                                AlertUpdate("APPROVED")
                            } else {
                                displayAlertMessage('danger', "This user don't have permission to modify !")
                                AlertUpdate("REJECTED")
                            }
                        } else if (operation == "Delete") {
                            if (Delete == true) {
                                handleDelete()
                                AlertUpdate("APPROVED")
                            } else {
                                displayAlertMessage('danger', "This user don't have permission to delete !")
                                AlertUpdate("REJECTED")
                            }
                        } else if (operation == "Print") {
                            if (Print == true) {
                                setprintoptionShow(true)
                                AlertUpdate("APPROVED")
                            } else {
                                displayAlertMessage('danger', "This user don't have permission to print !")
                                AlertUpdate("REJECTED")
                            }
                        } else if (operation == "XCEL") {
                            if (Print == true) {
                                handlePrint("XCEL")
                                AlertUpdate("APPROVED")
                            } else {
                                displayAlertMessage('danger', "This user don't have permission to print !")
                                AlertUpdate("REJECTED")
                            }
                        }
                    }
                    )
            } else if (Response.status == "400") {
                setDisabled(false)
                setDisabledCode(false)
                clearPermissionInputs()
                displayAlertMessage('danger', "Oops something went wrong !")
                AlertUpdate("REJECTED")
            } else if (Response.status == "403") {
                setDisabled(false)
                setDisabledCode(false)
                clearPermissionInputs()
                displayAlertMessage('danger', "You have not Permission to make changes !")
                AlertUpdate("REJECTED")
            } else if (Response.status == "404") {
                setDisabled(false)
                setDisabledCode(false)
                clearPermissionInputs()
                displayAlertMessage('danger', "Password or User Name is Invalid !")
                AlertUpdate("REJECTED")
            } else {
                ClearItem()
            }
        }).catch(error => {
            console.log(error.message)
        })
    }

    //Remote Access alert geneartion and websocket connection 
    async function RemoteAccess(right) {

        menurightaccept = right

        const currentDate = new Date();
        currentDate.setSeconds(currentDate.getSeconds() + 120);

        const timeout = moment(currentDate).format('YYYY-MM-DD HH:mm:ss');
        const requestedDateTime = moment(currentDate).format('YYYY-MM-DDTHH:mm:ss.000Z');

        universalID = uuid() //universan unique ID generation 

        updateUrld = `${ApiURL}Longpoling/UpdateMessage/${universalID}`

        var code = addNew == true && nullCode == false ? autoCode : strCompCode //strCompCode need to chenge in every master

        setPutrequest(updateUrld)
        setUniqueid(universalID)
        setMenuRight(right)
        setPutreqdate(requestedDateTime)

        var requestOptions = {
            "strLocCode": LocationCode,
            "strCompCode": LogCompanyCode,
            "strMenuCode": menuCode,
            "strMenuRight": right
        }

        try {
            const userGroupResponse = await FetchUserGroups(requestOptions) //fetch user groups from API

            if (userGroupResponse.success) {
                setAlertUserGroups(userGroupResponse.data)

                const portIdResponse = await FetchPortID() //fetch myalert running port from API

                if (portIdResponse.success) {

                    setAlertPort(portIdResponse.data)

                    var requestObject = {
                        "apiURL": `${ApiURL}Longpoling/UpdateMessage/${universalID}`,
                        "menuCode": menuCode,
                        "option": right,
                        "userGroup": userGroupResponse.data,
                        "menuName": menuName,
                        "location": locationName,
                        "locationCode": LocationCode,
                        "refCode": code,
                        "user": LogUserType,
                        "uuid": universalID,
                        "timeout": timeout,
                        "messageId": universalID,
                        "requestedDateTime": requestedDateTime,
                        "requested": true,
                        "processed": false
                    }

                    var token = jwt.sign(requestObject, "myposJWTauthentication")
                    requestObject["token"] = token

                    await sendApprovalNotification(portIdResponse.data, requestObject)

                    const publishMessageResponse = await PublishMessage(universalID, requestedDateTime)

                    if (publishMessageResponse.success) {
                        PermissionAccept(publishMessageResponse.data)
                    }
                }
            }
        } catch (error) {
            console.log(error)
        }

    }

    //web socket message listener function 
    async function PermissionAccept(event) {

        const response = event
        permissionedReason.current = response.reason


        const deviceUserResponse = await FetchDeviceUserDetails(response.deviceToken)

        if (deviceUserResponse.success) {
            permissionedUser.current = deviceUserResponse.data
            setPermissionName(deviceUserResponse.data)

            if (response.uuID == universalID) {

                if (response.permission == "true" && response.menucode == menuCode && response.uuID == universalID) {

                    setPermissionName(deviceUserResponse.data)
                    setPermissionGrantedAlertShow(true)
                    setPermissionGrantedAlertColor("success")
                    setPermissionGrantedAlertMsg("Permission Granted By " + deviceUserResponse.data + " please wait...")

                    setTimeout(() => {

                        setPermissionGrantedAlertShow(false)
                        setPermissionAlertShow(false)
                        if (response.right == menurightaccept) {
                            handlesave()
                        } else if (response.right == menurightaccept) {
                            handlesave()
                        } else if (response.right == menurightaccept) {
                            handleDelete()
                        } else if (response.right == menurightaccept) {
                            setprintoptionShow(true)
                        }

                    }, 3000)

                } else {
                    setPermissionGrantedAlertShow(true)
                    setPermissionGrantedAlertColor("danger")
                    setPermissionGrantedAlertMsg("Permission Denied By " + deviceUserResponse.data)

                    setTimeout(() => {
                        setPermissionGrantedAlertShow(false)
                        setPermissionAlertShow(false)
                    }, 3000)

                }

            }
        }
    }


    //Function for display Alert Messages
    function displayAlertMessage(color, message) {
        setAlertColor(color)
        setAlertMsg(message)
        setShow(true)

        setTimeout(() => {
            setShow(false)
        }, time)
    }


    //handle permission alert
    function handlePermissionAlert(LogUserType, reason, disable, alertShow) {
        setPermissionName(LogUserType)
        setReason(reason)
        setPermissionNameDisable(disable)
        setPermissionAlertShow(alertShow)
    }


    //Clear permission name & password
    function clearPermissionInputs() {
        setPermissionName("");
        setPermissionPassword("");
        setReason("");
    }

    //Handle Favourite Button
    const handleFavourite = async () => {
        var response = await addtoFavourite(menuCode, LogUserType);
    }

    return (
        < React.Fragment >
            <div className="page-content">
                <MetaTags>
                    <title>{menuName}</title>
                </MetaTags>
                <Container fluid={true}>
                    <Breadcrumb title={parentName}
                        breadcrumbItem={menuName}>

                    </Breadcrumb>
                    <DPAlert
                        confirm_both={sweetAlertShow}
                        title={menuName}
                        description={AlertDescription}
                        showCancel={true}
                        btnColor={"success"}
                        cancelColor={"danger"}
                        onConfirm={async () => {
                            setsweetAlertShow(false)
                            setPermissionName(LogUserType)
                            if (AlertConfirmOption == 1 || AlertConfirmOption == 7) {
                                if (addNew == true && menuCreate == true && permissionReasonShow == false) {
                                    handlesave()
                                } else if (addNew == true && menuCreate == true && permissionReasonShow == true) {
                                    handlePermissionAlert(LogUserType, "Created", true, true)
                                } else if (addNew == false && menuModify == true && permissionReasonShow == false) {
                                    handlesave()
                                } else if (addNew == false && menuModify == true && permissionReasonShow == true) {
                                    handlePermissionAlert(LogUserType, "Updated", true, true)
                                } else {
                                    setPermissionReasonShow(true)
                                    setPermissionAlertShow(true)
                                    setPermissionName("")
                                }

                            } else if (AlertConfirmOption == 2) {
                                handleEdit()
                            } else if (AlertConfirmOption == 3) {
                                history.push('/dashboard')
                            } else if (AlertConfirmOption == 4) {
                                handleNew()
                            } else if (AlertConfirmOption == 5) {
                                if (addNew == false && menuDelete == true && permissionReasonShow == false) {
                                    handleDelete()
                                } else if (addNew == false && menuDelete == true && permissionReasonShow == true) {
                                    handlePermissionAlert(LogUserType, "Deleted", true, true)
                                } else {
                                    setPermissionReasonShow(true)
                                    setPermissionAlertShow(true)
                                }
                            } else if (AlertConfirmOption == 6) {
                                // setMenuRight("R")
                                if (menuPrint == true && permissionReasonShow == false) {
                                    setprintoptionShow(true)
                                } else if (menuPrint == true && permissionReasonShow == true) {
                                    handlePermissionAlert(LogUserType, "Printed", true, true)
                                } else {
                                    setPermissionReasonShow(true)
                                    setPermissionAlertShow(true)
                                }
                            }

                            //Remote Access Method Call start
                            if (addNew == true && menuCreate == false && AlertConfirmOption == 1) {
                                RemoteAccess("C")
                            } else if (addNew == false && editCheck == true && menuModify == false && AlertConfirmOption == 7) {
                                RemoteAccess("M")
                            } else if (menuDelete == false && AlertConfirmOption == 5) {
                                RemoteAccess("D")
                            } else if (menuPrint == false && AlertConfirmOption == 6) {
                                RemoteAccess("R")
                            }
                            //Remote Access Method Call end

                        }}
                        onCancel={() => {
                            setsweetAlertShow(false)
                        }}
                    />
                    <DPPermission
                        confirm_both={permissionAlertShow}
                        title={menuName}
                        description={permissionAlertTitle}
                        showReason={permissionReasonShow}
                        nameDisable={permissionNameDisable}//{false}
                        showCancel={true}
                        btnColor={"success"}
                        cancelColor={"danger"}
                        AlName={permissionName}
                        show={permissionGrantedAlertShow}
                        AlertColor={permissionGrantedAlertColor}
                        AlertMsg={permissionGrantedAlertMsg}
                        AlNameOnchange={e => {
                            let val2 = Text(e.target, 50, true, false, "any", false)
                            setPermissionName(val2)
                        }}
                        AlPassward={permissionPassword}
                        AlPasswardOnchange={e => {
                            let val2 = Text(e.target, 50, true, true, "any", false)
                            setPermissionPassword(val2)
                        }}
                        AlReason={Reason}
                        AlReasonOnchange={e => {
                            let val2 = Text(e.target, 50, true, false, "any", true)
                            setReason(val2)
                        }}
                        onConfirm={() => {

                            setPermissionAlertShow(false)
                            if (AlertConfirmOption == 1) {
                                PermissionCheck("Save")
                            } else if (AlertConfirmOption == 7) {
                                PermissionCheck("Modify")
                            } else if (AlertConfirmOption == 5) {
                                PermissionCheck("Delete")
                            } else if (AlertConfirmOption == 6) {
                                PermissionCheck("Print")
                            }
                        }}
                        onCancel={() => {
                            setPermissionAlertShow(false)
                            clearPermissionInputs()


                            fetch(putrequest, {
                                method: "PUT",
                                headers: {
                                    "Content-Type": "application/json",
                                },
                                body: JSON.stringify({
                                    "header": {
                                        "messageId": uniqueid,
                                        "requestedDateTime": putreqdate,
                                        "requested": true,
                                        "processed": true
                                    },
                                    "body": null
                                })
                            }).then(Response => Response.json())
                                .then(responseData => {
                                    console.log(responseData)
                                }).catch(errorr => {
                                    console.log(errorr)
                                }).catch(error => {
                                    console.log(error)
                                })

                            AlertUpdate("CANCELLED")
                        }}
                    />
                    <DPPrintOption
                        confirm_both={printoptionShow}
                        title={menuName}
                        showCancel={true}
                        cancelColor={"danger"}
                        onConfirmpdf={() => {
                            handlePrint("PDF")
                            setprintoptionShow(false)
                        }}
                        onConfirmxcel={() => {
                            handlePrint("XCEL")
                            setprintoptionShow(false)
                        }}
                        onCancel={() => {
                            setprintoptionShow(false)
                        }}
                    />
                    <DPLoadingAlert
                        confirm_both={loadingAlert}
                        title={loadingAlertTitle}
                    />
                    <Row>
                        <Col lg={12}>
                            <Card>
                                <CardBody>
                                    <DPTopToolBar
                                        //Help Button
                                        helpEnable={helpUrl != "" ? true : false}
                                        helpClick={() => {
                                            window.open(helpUrl)
                                        }}
                                        //Favorite Button
                                        favoriteEnable={true}
                                        favoriteClick={handleFavourite}
                                        //New Button
                                        newEnable={true}
                                        newClick={() => {
                                            setAlertDescription("Do you wish to refresh the screen ?");
                                            setAlertConfirmOption(4)
                                            setsweetAlertShow(true)
                                        }}
                                        //Save Button
                                        saveEnable={saveEnable && isHeadOffice}
                                        saveClick={() => {
                                            setAlertDescription("Do you wish to save ?");
                                            setAlertConfirmOption(addNew ? 1 : 7)
                                            setsweetAlertShow(true)
                                        }}
                                        //ProcessButton
                                        processEnable={false}
                                        processClick={() => {
                                            alert("Process")
                                        }}
                                        //Edit Button
                                        editEnable={editEnable && isHeadOffice}
                                        editClick={() => {
                                            setAlertDescription("Do you wish to edit ?");
                                            setAlertConfirmOption(2)
                                            setsweetAlertShow(true)
                                        }}
                                        //Print Button

                                        printEnable={true}
                                        printClick={() => {
                                            setReason("Printed")
                                            setAlertDescription("Do you wish to print ?");
                                            setAlertConfirmOption(6)
                                            setsweetAlertShow(true)
                                        }}
                                        //Delete Button
                                        deleteEnable={deleteEnable}
                                        deleteClick={() => {
                                            setReason("Deleted")
                                            setAlertDescription("Do you wish to delete ?");
                                            setAlertConfirmOption(5)
                                            setsweetAlertShow(true)
                                        }}
                                        //Exit Button
                                        exitEnable={true}
                                        exitClick={() => {
                                            setAlertDescription("Do you wish to exit ?");
                                            setAlertConfirmOption(3)
                                            setsweetAlertShow(true)
                                        }}
                                    />
                                    <Row>
                                        <CompanyMasterContent
                                            GetSelectRow={GetSelectRow}
                                            CodeValue={strCompCode}
                                            CodeTooltip={ttCode}
                                            CodeonChange={e => {
                                                let val1 = Text(
                                                    e.target,
                                                    5,
                                                    true,
                                                    false,
                                                    "upper",
                                                    false
                                                )
                                                SetCode(val1)
                                            }}
                                            DescValue={strCompDesc}
                                            DescToolTip={ttDescription}
                                            DescOnChange={e => {
                                                let val2 = Text(
                                                    e.target,
                                                    50,
                                                    true,
                                                    false,
                                                    "any",
                                                    true
                                                )
                                                SetDescription(val2)
                                            }}
                                            ActiveSw={IsActive}
                                            ActiveToolTip={ttStatus}
                                            SwonChange={() => {
                                                SetActive(!IsActive)
                                            }}
                                            modelTrigger={tog_xlarge}
                                            modelOpen={modal_xlarge}
                                            show={show}
                                            disabled={disabled}
                                            disabledCode={disabledCode}
                                            AlertColor={AlertColor}
                                            AlertMsg={AlertMsg}
                                            CodeOnBlur={e => {
                                                getData(e.target.value)
                                            }}
                                            ErrorMsg={ErrorMsg}
                                            menuName={menuName}
                                            onButtonClick={e => {
                                                AutoGenerateCode()
                                                setCodeButton(true)
                                            }}
                                            btnDisable={codeButton}
                                            SearchDisable={searchdisabled}
                                            showFileUpload={(e) => {
                                                const file = e.target.files[0];
                                                readExcel(file);
                                                setvalueUpload(e.target.value)
                                            }}
                                            valueUpload={valueUpload}
                                            menuCode={menuCode}
                                            autoCode={autoCode}
                                        />
                                    </Row>
                                    <Row>
                                        {crEnable ? (
                                            <DPInfoBox
                                                createdBy={crBy}
                                                createdOn={crDate != '1900-01-01T00:00:00' ? (crDate) ? crDate.replace('T', ' ') : "" : ''}
                                                modifiedBy={mdBy}
                                                modifiedOn={mdDate != '1900-01-01T00:00:00' ? (mdDate) ? mdDate.replace('T', ' ') : "" : ''}
                                            />
                                        ) : null}
                                    </Row>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>

        </React.Fragment >
    )

}

export default CompanyMaster


















// async function RemoteAccess(right) {

//     var portID = ""
//     var userGroups

//     universalID = uuid() //universan unique ID generation
//     setUniqueid(universalID)

//     setMenuRight(right)
//     menurightaccept = right


//     var requestOptions = {
//         "strLocCode": LocationCode,
//         "strCompCode": LogCompanyCode,
//         "strMenuCode": menuCode,
//         "strMenuRight": right
//     }

//     const userGroupResponse = await FetchUserGroups(requestOptions)

//     if (userGroupResponse.success) {
//         userGroups = userGroupResponse.data
//         setAlertUserGroups(userGroupResponse.data)
//     }

//     // await fetch(`${ApiURL}Common/RemoteAccept`, {
//     //     method: "POST",
//     //     headers: {
//     //         "Content-Type": "application/json",
//     //         "Authorization": `Bearer ${authToken}`
//     //     },
//     //     body: JSON.stringify(requestOptions)
//     // }).then(async (Response) => await Response.json())
//     //     .then(responseData => {
//     //         userGroups = responseData.data.map(function (item) {
//     //             return item['userGroup'];
//     //         });
//     //         setAlertUserGroups(userGroups)
//     //     }).catch((error) => {
//     //         console.log(error)
//     //     })

//     await fetch(`${ApiURL}Common/GetPortID`, {
//         method: "GET",
//         headers: {
//             "Content-Type": "application/json",
//             "Authorization": `Bearer ${authToken}`
//         }
//     }).then(async (Response) => await Response.json())
//         .then(responseData => {
//             portID = responseData.data
//             setAlertPort(responseData.data)
//         })


//     var code = addNew == true && nullCode == false ? autoCode : strCompCode

//     var date1 = new Date()
//     date1.setSeconds(date1.getSeconds() + 120)
//     var date = moment(date1).format('YYYY-MM-DD HH:mm:ss');
//     date2 = moment(date1).format('YYYY-MM-DD') + "T" + moment(date1).format('HH:mm:ss') + ".000Z"

//     setPutreqdate(date2)
//     updateUrld = `${ApiURL}Longpoling/UpdateMessage/${universalID}`
//     setPutrequest(updateUrld)

//     var obj = {
//         "apiURL": `${ApiURL}Longpoling/UpdateMessage/${universalID}`,
//         "menuCode": menuCode,
//         "option": right,
//         "userGroup": userGroups,
//         "menuName": menuName,
//         "location": locationName,
//         "locationCode": LocationCode,
//         "refCode": code,
//         "user": LogUserType,
//         "uuid": universalID,
//         "timeout": date,
//         "messageId": universalID,
//         "requestedDateTime": date2,
//         "requested": true,
//         "processed": false
//     }

//     var token = jwt.sign(obj, "myposJWTauthentication")
//     obj["token"] = token
//     delete obj["socketURl"]

//     fetch(`${myAlertURL + portID}/notification/approval`, {
//         method: "POST",
//         headers: {
//             "Content-Type": "application/json",
//             "Authorization": `Bearer ${authToken}`
//         },
//         body: JSON.stringify(obj)
//     }).then(Response => Response.json())
//         .then(responseData => {
//             console.log(responseData)
//         })


//     fetch(`${ApiURL}Longpoling/PublishMessage`, {
//         method: "POST",
//         signal: signal,
//         headers: {
//             "Content-Type": "application/json",
//             "Authorization": `Bearer ${authToken}`
//         },
//         body: JSON.stringify({
//             "header": {
//                 "messageId": universalID,
//                 "requestedDateTime": date2,
//                 "requested": true,
//                 "processed": false
//             },
//             "body": {
//                 "deviceToken": "",
//                 "reason": "",
//                 "uuID": "",
//                 "permission": "",
//                 "menucode": "",
//                 "right": "",
//             }
//         })
//     }).then(Response => Response.json())
//         .then(responseData => {
//             if (responseData.data) {
//                 if (responseData.data.status != 0 && responseData.data.body != null) {
//                     PermissionAccept(responseData.data.body)
//                 }
//             }
//         }).catch(errorr => {
//             console.log(errorr)
//         }).catch(error => {
//             console.log(error)
//         })


// }